import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnersModule } from '@cradua/spinners';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';
import { ViewprogressComponent } from './component/viewprogress/viewprogress.component';
import { ViewprogressContainerComponent } from './container/viewprogress-container/viewprogress-container.component';
import { SearchComponent } from './component/search/search.component';
import { AdrlistComponent } from './component/adrlist/adrlist.component';
import { AdrcounselComponent } from './component/viewprogress/adrcounsel/adrcounsel.component';
import { AssetsindisputeComponent } from './component/viewprogress/assetsindispute/assetsindispute.component';
import { DocumentComponent } from './component/viewprogress/adrdocument/document.component';
import { DocumentTableComponent } from './component/viewprogress/adrdocument/document-table/document-table.component';
import { ExcelDocumentUploadViewComponent } from './component/viewprogress/adrdocument/document-table/excel-document-upload-view/excel-document-upload-view.component';
import { AdrpersonnelComponent } from './component/viewprogress/adrpersonnel/adrpersonnel.component';
import { AdrFacade } from './states/+adr/adr.facade';
import { AdrEffects } from './states/+adr/adr.effects';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { RouterModule } from '@angular/router';
import { AdrProgressRoutingModule } from './adrprogress-routing.module';
import * as adrprogressReducer from "./states/+adr/adr.reducer";
import { SuitprogressComponent } from './component/viewprogress/suitprogress/suitprogress.component';
import { GenericDocumentModule } from "../../../generic-document/src/lib/generic-document.module";
import { DocumentFacade } from "../../../generic-document/src/lib/document-states/document.facade";
import { GatewayFacade } from "libs/gateway/src/lib/states/+gateway/gateway.facades";

@NgModule({
  imports: [CommonModule,
  RouterModule,
    AdrProgressRoutingModule,
    EpimsDashboardNavModule,
    SpinnersModule,
    ReactiveFormsModule,
    GenericDocumentModule,
    AngularMaterialModule,
    StoreModule.forFeature(
      adrprogressReducer.ADRPROGRESS_FEATURE_KEY,
      adrprogressReducer.reducer
    ),
  EffectsModule.forFeature([
    AdrEffects
  ])
  
],
  providers: [AdrFacade, DocumentFacade, GatewayFacade],
  declarations: [ViewprogressComponent, ViewprogressContainerComponent, SearchComponent, AdrlistComponent, AdrcounselComponent, AssetsindisputeComponent, DocumentComponent, AdrpersonnelComponent, SuitprogressComponent, DocumentTableComponent, ExcelDocumentUploadViewComponent],
})
export class AdrProgressModule {}
